// As this grows we can split into separate files in a "styled" folder
import { css } from "styled-components";
import { darken, lighten } from "polished";

/**
 * Z-index
 */

export const desktop_header_z_index = 4;
export const sidebar_z_index = 3;
export const mobile_header_z_index = 2;
export const mobile_description_z_index = 2;
export const mobile_sticky_header_z_index = 1;
export const confirm_alert_z_index = 1;
export const mobile_search_preview_z_index = 1;

/**
 * Colors
 */

export const color_increment = 0.15;

export const gray = "#93A1A9";
export const gray_darkest = darken(color_increment * 2, gray);
export const gray_lightest = lighten(color_increment * 2, gray);
export const green = "#3c6";
export const yellow = "#ffd153";
export const red = "#CC334B";
export const red_lightest = "#f9eaed";
export const blue = "#3384CC";
export const white = "#ffffff";
export const off_white = "#f6f7f9";
export const black = "#2E3538";
export const dark_blue = "#48545b";
export const orange = "#f19f00";

/**
 * Media Queries
 */

const sizes = {
  extraWide: 1230,
  container: 1040,
  tabletXL: 1024,
  tablet_large: 880,
  mobile_width: 767,
  tablet: 725,
  phone_large: 570,
  phone: 430,
};

type MediaType = {
  extraWide?: (string) => string;
  container?: (string) => string;
  tabletXL?: (string) => string;
  tablet_large?: (string) => string;
  mobile_width?: (string) => string;
  tablet?: (string) => string;
  phone_large?: (string) => string;
  phone?: (string) => string;
};

// Convenience utility for declaring media queries
// Ex: `${media.tablet_xl`font-size: 10px;`}`
export const media: MediaType = Object.keys(sizes).reduce(
  (accumulator, label) => {
    // convert pixels to ems
    const emSize = sizes[label] / 16;
    accumulator[label] = (arg1, ...args: string[]) => css`
      @media (max-width: ${emSize}em) {
        ${css(arg1, ...args)}
      }
    `;
    return accumulator;
  },
  {}
);
